import React, { useEffect, useState } from "react";
import XbuttonGrowth from "graphics/icons/XbuttonGrowth.js";
import XbuttonBusiness from "graphics/icons/XbuttonBusiness.js";
import TreeAnimate from "./TreeAnimate";

const StartModal = (props) => {
  const [show, setShow] = useState(false);
  const onDismiss = () => {
    setShow(false);
    setTimeout(props.onDismiss, 300); //timeout duration to be kept same as animation duration
  };

  useEffect(() => {
    // Made this timeout to force React to render with an initial state of show=false
    setTimeout(() => {
      setShow(true);
    }, 50);
  }, []);
  return (
    <div
      className={`home-start-backdrop ${show ? "" : "hide"} `}
      onClick={props.noBackDropClick ? null : onDismiss}
    >
      <div
        className="home-start-box form-shadow"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={`my-modal-header ${
            props.growth ? "growth-text" : "business-text"
          }`}
        >
          {props.header}
          <div className="modal-exit" onClick={onDismiss}>
            {props.growth ? <XbuttonGrowth /> : <XbuttonBusiness />}
          </div>
        </div>

        <div>{props.content}</div>
        <div className="modal-actions">{props.actions}</div>
      </div>
      <TreeAnimate />
    </div>
  );
};

export default StartModal;
